import moment from "moment";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";

import { getButtonBgColor, getFontFamily } from "slices";

const MonthShow = ({ onClickMonth, selectedDate }) => {
  const color = useSelector(getButtonBgColor);
  const fontFamily = useSelector(getFontFamily);

  return (
    <div className="hayley-col-span-7 hayley-grid hayley-grid-cols-3 hayley-gap-y-2">
      {moment.months().map((month, i) => (
        <Button
          key={i}
          className={`hayley-custom hayley-flex hayley-h-12 hayley-min-h-fit hayley-w-full hayley-min-w-fit hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-rounded-none hayley-border hayley-border-solid hayley-border-transparent hayley-font-opensans hayley-text-sm hayley-font-semibold hayley-normal-case hayley-text-secondary ${
            month == moment(selectedDate).format("MMMM") ? "hayley-bg-secondary/10" : " hayley-bg-transparent"
          } `}
          sx={{
            "&.hayley-custom": {
              fontFamily: `${fontFamily} !important`,
              "&:hover": { borderColor: `${color} !important` },
            },
          }}
          onClick={() => onClickMonth(i)}
        >
          {month.slice(0, 3)}
        </Button>
      ))}
    </div>
  );
};

export default MonthShow;
